import { api, setCsrfToken } from './client'
import type { PollResponse, QrResponse, SessionResponse } from '../types/api'
import type { SessionUser } from '../types/api'

type UserPayload = Partial<SessionUser> & Record<string, unknown>

function stringValue(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined
}

/** 在 API 边界一次性规范化支持的用户资料别名。 */
export function normalizeSessionUser(value: unknown): SessionUser | undefined {
  if (!value || typeof value !== 'object') return undefined
  const raw = value as UserPayload
  const mid = stringValue(raw.bilibili_mid) || stringValue(raw.mid)
  const id = stringValue(raw.id) || mid
  if (!id) return undefined
  const nickname = stringValue(raw.nickname) || stringValue(raw.name) || stringValue(raw.uname)
  const avatarUrl = stringValue(raw.avatar_url) || stringValue(raw.face) || stringValue(raw.avatar)
  const profileStatus = stringValue(raw.profile_status)
  return {
    id,
    ...(mid ? { bilibili_mid: mid, mid } : {}),
    ...(nickname ? { name: nickname, nickname } : {}),
    ...(avatarUrl ? { face: avatarUrl, avatar_url: avatarUrl } : {}),
    ...(profileStatus ? { profile_status: profileStatus } : {}),
  }
}

function normalizeSession(session: SessionResponse): SessionResponse {
  const user = normalizeSessionUser(session.user || session.profile)
  if (user && !user.profile_status && session.profile_status) user.profile_status = session.profile_status
  return { ...session, user }
}

export async function getSession() {
  const session = normalizeSession(await api<SessionResponse>('/api/auth/session'))
  setCsrfToken(session.csrf_token)
  return session
}
export async function createQr() { return api<QrResponse>('/api/auth/bilibili/qrcode', { method: 'POST' }) }
/** 从服务端权威的 B站凭据接口刷新用户资料。 */
export function refreshProfile() {
  return api<unknown>('/api/auth/profile/refresh', { method: 'POST' })
}
export async function pollQr(qrcode_key: string) {
  const result = await api<PollResponse>(`/api/auth/bilibili/poll?qrcode_key=${encodeURIComponent(qrcode_key)}`)
  if (result.csrf_token) setCsrfToken(result.csrf_token)
  return { ...result, user: normalizeSessionUser(result.user) }
}
export async function logout() { await api('/api/auth/logout', { method: 'POST' }); setCsrfToken() }
export async function disconnectBilibili() { await api('/api/auth/bilibili', { method: 'DELETE' }); setCsrfToken() }
